import React, { useMemo } from 'react';
import { Card, DataCell, DataList, Text } from '@/components/ui';

interface ImportBasicInfoProps {
  id: number;
  createdAt: string;
  updatedAt?: string;
  createdBy?: {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
  };
}

export const ImportBasicInfo: React.FC<ImportBasicInfoProps> = ({
  id,
  createdAt,
  updatedAt,
  createdBy,
}) => {
  const items = useMemo(() => {
    const dataListItems: Array<{
      label: string;
      value: React.ReactNode;
    }> = [
      {
        label: 'Mapping ID',
        value: <DataCell noWrapper type="id" value={id} size="small" />,
      },
      {
        label: 'Created At',
        value: (
          <DataCell
            noWrapper
            type="datetime"
            value={createdAt}
            size="small"
            relative={false}
          />
        ),
      },
    ];

    if (updatedAt) {
      dataListItems.push({
        label: 'Last Updated',
        value: (
          <DataCell
            noWrapper
            type="datetime"
            value={updatedAt}
            size="small"
            relative={false}
          />
        ),
      });
    }

    if (createdBy) {
      dataListItems.push({
        label: 'Created By',
        value: (
          <DataCell
            noWrapper
            type="user"
            user={{
              id: createdBy.id,
              email: createdBy.email,
              first_name: createdBy.first_name,
              last_name: createdBy.last_name,
            }}
            size="small"
            viewMode="compact"
            showEmail={true}
          />
        ),
      });
    }

    return dataListItems;
  }, [id, createdAt, updatedAt, createdBy]);

  return (
    <Card>
      <Text size="4" weight="medium" mb="3">
        Mapping Information
      </Text>
      <DataList items={items} size="small" orientation="horizontal" />
    </Card>
  );
};
